import { MYPAGE_DASHBOARD } from '@/components/organisms/main/mypage/types';
import router from '@/router';
import { createStore, useStore as baseUseStore } from 'vuex';
export const key = Symbol();
export const state = {
    userSettings: {
        language: 'English',
        isSound: true,
        isCancelLeave: false,
        isOrderLeave: false,
        localTime: 'Etc/UTC',
        isLimitedOpenPair: false,
        isLimitedClosePair: false,
    },
    theme: null,
    symbol: {
        pair: '',
        base: '',
        quote: '',
    },
    balances: [],
    latestValue: 0,
    latestAmount: 0,
    latestCount: 0,
    last24Value: 0,
    last24High: 0,
    last24Low: 0,
    currencyInfo: [],
    currencyPairInfo: [],
    latestPrices: [],
    orderCount: 0,
    order: {
        price: 0,
        amount: 0,
    },
    chart: {
        isFull: false,
        interval: '60',
    },
    openList: [],
    closedList: [],
    isSmartPhone: false,
    tab: 'trade',
    mypageTab: MYPAGE_DASHBOARD,
    stakeCrypto: {
        stepIs: 0,
        cardIs: 0,
        planCardIs: 0,
        cardIsBool: false,
        planCardIsBool: false,
        stakeAmountBool: false,
        stakeConfirmBool: false,
        isCompleteBool: false,
        stakeAmount: 0,
    },
    unreadNotificationCount: 0,
};
export const mutations = {
    setTheme: (state, theme) => {
        localStorage.setItem('focrex.theme', theme);
        state.theme = theme;
    },
    setSymbol: (state, symbol) => {
        localStorage.setItem('focrex.symbol', JSON.stringify(symbol));
        state.symbol = symbol;
        router.push({ path: '/trade', query: { c: `${state.symbol.base}_${state.symbol.quote}`, tab: state.tab } });
    },
    setCurrencyInfo: (state, info) => {
        state.currencyInfo = info;
    },
    setCurrencyPairInfo: (state, info) => {
        state.currencyPairInfo = info;
    },
    countUpOder: (state) => {
        state.orderCount += 1;
    },
    setLatestValue: (state, value) => {
        state.latestValue = value.price;
        state.latestAmount = value.amount;
        // Low & High
        if (value.price > store.state.last24High) {
            store.state.last24High = value.price;
        }
        if (value.price < store.state.last24Low) {
            store.state.last24Low = value.price;
        }
        state.latestCount += 1;
        document.title = `${state.latestValue} | ${state.symbol.pair} | CRYPTOS`;
    },
    setChartIsFull: (state, value) => {
        localStorage.setItem('focrex.chart.isfull', String(value));
        state.chart.isFull = Boolean(value);
    },
    setChartInterval: (state, value) => {
        localStorage.setItem('focrex.chart.interval', value);
        state.chart.interval = value;
    },
};
export const getters = {
    theme: (state) => {
        const theme = localStorage.getItem('focrex.theme');
        state.theme = theme || 'Dark';
        return theme || 'Dark';
    },
    symbol: (state) => {
        const symbol = localStorage.getItem('focrex.symbol');
        if (symbol) {
            state.symbol = JSON.parse(symbol);
            return JSON.parse(symbol);
        }
        return null;
    },
    currencyInfo: (state) => {
        return state.currencyInfo;
    },
    latestValue: (state) => {
        return state.latestValue;
    },
    chartInterval: () => {
        const interval = localStorage.getItem('focrex.chart.interval');
        return interval || '60';
    },
};
export const store = createStore({
    state: state,
    mutations: mutations,
    getters: getters,
});
export const useStore = () => {
    return baseUseStore(key);
};
